import i18n from "../../i18n"
import { ICON } from "../Icon/data"
import { MapOptions } from "./type"

export enum MAP_TYPE_IDS {
  OPEN_STREETMAP = 'open_streetmap',
  GOOGLE_ROADMAP = 'google_roadmap',
  GOOGLE_SATELLITE = 'google_sattelite',
  GOOGLE_TERRAIN = 'google_terrain',
  GOOGLE_HYBRID = 'google_hybrid'
}

export const MAP_TYPES = {
  [MAP_TYPE_IDS.OPEN_STREETMAP]: {
    id: MAP_TYPE_IDS.OPEN_STREETMAP,
    label: i18n.t('Open Streetmap')
  },
  [MAP_TYPE_IDS.GOOGLE_ROADMAP]: {
    id: MAP_TYPE_IDS.GOOGLE_ROADMAP,
    label: i18n.t('Google Roadmap'),
    logo: 'google'
  },
  [MAP_TYPE_IDS.GOOGLE_SATELLITE]: {
    id: MAP_TYPE_IDS.GOOGLE_SATELLITE,
    label: i18n.t('Google Satellite'),
    logo: 'google'
  },
  [MAP_TYPE_IDS.GOOGLE_TERRAIN]: {
    id: MAP_TYPE_IDS.GOOGLE_TERRAIN,
    label: i18n.t('Google Terrain'),
    logo: 'google'
  },
  [MAP_TYPE_IDS.GOOGLE_HYBRID]: {
    id: MAP_TYPE_IDS.GOOGLE_HYBRID,
    label: i18n.t('Google Hybrid'),
    logo: 'google'
  }
}

export enum MAP_VIEW_OPTIONS_IDS {
  ROAD_CONDITIONS = 'roadConditions',
  CLUSTER_MARKERS = 'clusterMarkers',
  CLUSTER_ICONS = 'clusterIcons',
  WEATHER = 'weather',
  LIVE_CAMS = 'liveCams'
}

export const MAP_VIEW_OPTIONS = {
  [MAP_VIEW_OPTIONS_IDS.ROAD_CONDITIONS]: {
    id: MAP_VIEW_OPTIONS_IDS.ROAD_CONDITIONS,
    label: i18n.t('Road conditions'),
    icon: ICON.ROAD_WEATHER,
    isVisible: (options: MapOptions) => options.showRoadConditions,
  },
  [MAP_VIEW_OPTIONS_IDS.WEATHER]: {
    id: MAP_VIEW_OPTIONS_IDS.WEATHER,
    label: i18n.t('Weather'),
    icon: ICON.WEATHER,
    isVisible: (options: MapOptions) => options.showWeather,
  },
  [MAP_VIEW_OPTIONS_IDS.LIVE_CAMS]: {
    id: MAP_VIEW_OPTIONS_IDS.LIVE_CAMS,
    label: i18n.t('Livecams'),
    icon: ICON.VIDEO,
    isVisible: (options: MapOptions) => options.showLiveCams,
  },
  [MAP_VIEW_OPTIONS_IDS.CLUSTER_MARKERS]: {
    id: MAP_VIEW_OPTIONS_IDS.CLUSTER_MARKERS,
    label: i18n.t('Clusters'),
    icon: ICON.CLUSTERS,
    isVisible: (options: MapOptions) => options.showClusterMarkers,
  },
  [MAP_VIEW_OPTIONS_IDS.CLUSTER_ICONS]: {
    id: MAP_VIEW_OPTIONS_IDS.CLUSTER_ICONS,
    label: i18n.t('Clusters'),
    icon: ICON.CLUSTERS,
    isVisible: (options: MapOptions) => options.showClusterIcons,
  },
}
